// extracted by mini-css-extract-plugin
module.exports = {"plus-button":"plus-button___QvLSf","plusButton":"plus-button___QvLSf","minus-button":"minus-button___lf9aX","minusButton":"minus-button___lf9aX"};